import { useEffect } from 'react';
import { isAerialImage, MediaItemV2 } from '../../../../../../app-kit/components/Image/types';

// As we're using the Virtual module from Swiper, we need to manually preload images because
// lazyPreloadPrevNext prop doesn't work with the Virtual module.
// We believe the potential performance hit will be substantial if we don't use Virtual slides
// as we know there are Properties with 50+ images.
//
// The gallery is mobile first, so we are preloading the mobile webp version of the listing images.

const preloadImage = (src: string) => {
  const img = document.createElement('img');
  img.src = src;
};

export const usePreloadSlideImage = (image: MediaItemV2['image']) => {
  useEffect(() => {
    let imageSrc: string = '';

    if (isAerialImage(image)) {
      imageSrc = image.uri;
    } else {
      imageSrc = image.mobileFullScreenImageWebpUri;
    }
    preloadImage(imageSrc);
  }, [image]);
};
